var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('md-progress-spinner',{attrs:{"md-diameter":30,"md-stroke":3,"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }